module.exports = __webpack_public_path__ + "static/img/cs2.c502603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cs2.jpg
// module id = /Zki
// module chunks = 1